import type { AccountModalActionType } from '$lib/services/tracking/googleAnalytics/events';
import { track } from '$lib/services/tracking/googleAnalytics';

const ACCOUNT_MODAL_CONTEXT = 'account_modal';
const ACCOUNT_MODAL_PAGENAME = 'profile.CreateAccountBenefits';

export const accountModalActions: Record<string, AccountModalActionType> = {
	signInAccountBtn: 'SignIn_account_btn',
	registerAccountBtn: 'register_account_btn',
	signInNlBtn: 'SignIn_nl_btn',
	magRedirection: 'mag_redirection',
};

export function trackAccountModalVisibility() {
	track({
		action: 'CreateAccount_modal',
		payload: {
			page_name: ACCOUNT_MODAL_PAGENAME,
			action: 'display',
			context: ACCOUNT_MODAL_CONTEXT,
		},
	});
}

export function trackAccountModalClick(action: AccountModalActionType) {
	track({
		action,
		payload: {
			page_name: ACCOUNT_MODAL_PAGENAME,
			action: 'click',
			context: ACCOUNT_MODAL_CONTEXT,
		},
	});
}

export function trackLoginButtonClick() {
	track({
		action: 'account_button',
		payload: { action: 'login' },
	});
}
